export enum ScopeSequenceLocalStorageKeys {
  Grade = 'grades',
  Skill = 'skills'
}
